import {
  Badge,
  Calendar,
  Card,
  Checkbox,
  Col,
  Divider,
  Row,
  Tooltip,
} from "antd";
import React, { CSSProperties, useCallback, useEffect, useState } from "react";
import type { Dayjs } from "dayjs";
import "./CalendatWithLabels.less";
import { connect } from "react-redux";
import { getPublicHoliday } from "../../redux/actions";
import dayjs from "dayjs";
import _ from "lodash";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import NumericInput from "./NumericInput";
import { Claim, ClaimDtl } from "../../types/RequestTypes";
import {
  APPROVER_STATUS_ARRAY,
  CALENDAR_DATE,
  CLAIM_STATUS,
  ENDORSER_STATUS_ARRAY,
  statusProcess,
  StatusWithEle,
  STATUS_ARRAY,
  todayWithRange,
} from "../../const/constant";
import formatAmount from "../../utility/formatAmount";

// const StatusWithEle = {
//   I: { color: "yellow", text: "Draft" },
//   W: { color: "green", text: "Submitted" },
//   S: { color: "blue", text: "Endorsed" },
//   P: { color: "purple", text: "Approved" },
//   R: { color: "magenta", text: "Rejected" },
// };

const defaultChecked = STATUS_ARRAY;

const BadgeCSS: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  flexWrap: "wrap",
  justifyContent: "center",
};

interface ClaimDetails {
  CLAIM_DATE: string;
  HR_CLAIM: number;
  CLAIM_AMT: number;
  CLAIM_RATE: number;
  ENDORSER: string | null;
  STATUS: string;
  IS_PAID: number;
  BATCH_NO: string;
}

function CalendarWithLabels(props) {
  const {
    fetchPublicHoliday,
    holidays,
    claims,
    device,
    validRange,
    changedHr,
    setChangedHr,
    disableFieldBefore,
    rateType,
    displayCheckBox = true,
    hasInput = true,
    isApprover,
    isEndorser,
    rejectedBatchNo,
  } = props;

  const [checkedList, setCheckedList] =
    useState<CheckboxValueType[]>(defaultChecked);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(true);
  const [defaultMonth, setDefaultMonth] = useState<Dayjs>(
    todayWithRange(validRange[0], validRange[1])
  );

  const SetValueWithRange = (value: Dayjs) => {
    if (value.isBefore(validRange[0], "date")) {
      setDefaultMonth(validRange[0]);
    } else if (value.isAfter(validRange[1], "date")) {
      setDefaultMonth(validRange[1]);
    } else {
      setDefaultMonth(value);
    }
  };

  const onDateSelect = (value: Dayjs) => {
    SetValueWithRange(value);
  };

  useEffect(() => {
    if (changedHr && rejectedBatchNo) {
      const rejectedDate = Object.keys(changedHr);
      const firstRejectedKey = rejectedDate[0];
      const firstRejectedDate = dayjs(firstRejectedKey);
      setDefaultMonth(firstRejectedDate);
    }
  }, [rejectedBatchNo]);

  const combineClaimDtlsByDate = (): ClaimDetails[] => {
    const claimDtls = claims
      .map((claim: Claim) => {
        return claim.CLAIMS_DETAILS
          ? claim.CLAIMS_DETAILS.map((claimDetail: ClaimDtl) => {
              return {
                ...claimDetail,
                ENDORSER: claim.ENDORSER,
                STATUS: claim.STATUS,
                IS_PAID: claim.IS_PAID,
                BATCH_NO: claim.BATCH_NO,
              };
            })
          : [];
      })
      .flatMap((dtl) => dtl);
    // console.log("*****claimDtls:", claimDtls);

    const initialValue: ClaimDetails[] = [];
    const result = claimDtls.reduce((acc, currentClaim) => {
      const isClaimDateExist = acc.some(
        (e) => e.CLAIM_DATE === currentClaim.CLAIM_DATE
      );
      // console.log('*****isClaimDateExist:', isClaimDateExist);

      if (isClaimDateExist) {
        const existedClaim = acc.find(
          (e) => e.CLAIM_DATE === currentClaim.CLAIM_DATE
        );
        if (existedClaim) {
          if (
            existedClaim.STATUS === CLAIM_STATUS.APPROVED &&
            currentClaim.STATUS === CLAIM_STATUS.APPROVED
          ) {
            acc = acc.filter((e) => e.CLAIM_DATE !== currentClaim.CLAIM_DATE);
            const newClaim: ClaimDetails = {
              CLAIM_DATE: existedClaim.CLAIM_DATE,
              HR_CLAIM: parseFloat(
                formatAmount(
                  existedClaim.HR_CLAIM + currentClaim.HR_CLAIM,
                  false
                )
              ),
              CLAIM_AMT: parseFloat(
                formatAmount(
                  existedClaim.CLAIM_AMT + currentClaim.CLAIM_AMT,
                  false
                )
              ),
              CLAIM_RATE: existedClaim.CLAIM_RATE,
              ENDORSER: null,
              STATUS: existedClaim.STATUS,
              IS_PAID: existedClaim.IS_PAID,
              BATCH_NO: existedClaim.BATCH_NO,
            };
            acc.push(newClaim);
            // console.log(`*****PP - ${currentClaim.CLAIM_DATE}:`, acc);
          } else if (
            existedClaim.STATUS !== CLAIM_STATUS.APPROVED &&
            currentClaim.STATUS === CLAIM_STATUS.APPROVED
          ) {
            acc = acc.filter((e) => e.CLAIM_DATE !== currentClaim.CLAIM_DATE);
            acc.push(currentClaim);
            // console.log(`*****NP - ${currentClaim.CLAIM_DATE}:`, acc);
          }
        }
      } else {
        acc.push(currentClaim);
        // console.log(`*****NN - ${currentClaim.CLAIM_DATE}:`, acc);
      }

      return acc;
    }, initialValue);

    return result;
  };

  const dateFullCellRender = useCallback(
    (date: Dayjs) => {
      const RenderHourlyBadge = (record: Claim, claim_dtl: ClaimDtl) => {
        const hourlyBadgeStyle =
          device.size === "desktop"
            ? {
                display: "flex",
                alignItems: "center",
              }
            : {
                innerWidth: "100%",
              };
        let newStatus = statusProcess(claim_dtl);
        if (!checkedList.includes(newStatus)) {
          return <></>;
        }
        if (record.ENDORSER) {
          return (
            // <Tooltip
            //   title={<>{record.ENDORSER}</>}
            //   trigger={device.size === "desktop" ? "hover" : "click"}
            //   placement="top"
            // >
              <Badge
                style={hourlyBadgeStyle}
                color={StatusWithEle[newStatus].color}
                text={`${claim_dtl.HR_CLAIM} hr(s)`}
              />
            // </Tooltip>
          );
        } else if (!record.ENDORSER && newStatus === "W") {
          return (
            <Badge
              style={hourlyBadgeStyle}
              color={StatusWithEle[newStatus].color}
              text={`${claim_dtl.HR_CLAIM} hr(s)`}
            />
          );
        } else {
          return (
            <Badge
              style={hourlyBadgeStyle}
              color={StatusWithEle[newStatus].color}
              text={`${claim_dtl.HR_CLAIM} hr(s)`}
            />
          );
        }
      };

      const RenderOtherBadge = (record: Claim) => {
        let newStatus = statusProcess(record);
        if (!checkedList.includes(newStatus)) {
          return <></>;
        }
        if (record.ENDORSER) {
          return (
            // <Tooltip
            //   title={<>{record.ENDORSER}</>}
            //   trigger={device.size === "desktop" ? "hover" : "click"}
            //   placement="top"
            // >
              <Badge
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
                color={StatusWithEle[newStatus].color}
                text={`${StatusWithEle[newStatus].text[0]}`}
              />
            // </Tooltip>
          );
        } else if (!record.ENDORSER && newStatus === "W") {
          return (
            <Badge
              style={{ display: "flex", alignItems: "center" }}
              color={StatusWithEle[newStatus].color}
              text={`${StatusWithEle[newStatus].text[0]}`}
            />
          );
        }
        return (
          <Badge
            style={{ display: "flex", alignItems: "center" }}
            color={StatusWithEle[newStatus].color}
            text={`${StatusWithEle[newStatus].text[0]}`}
          />
        );
      };
      const onFieldChange = (key: string, value: string) => {
        setChangedHr((prevH) => {
          const h = { ...prevH };
          const v = parseFloat(value) ? parseFloat(value) : 0;
          if (key in h) {
            h[key] = { ...h[key], hr: v };
          } else {
            h[key] = { date, hr: v, prevState: "", prevH: 0 };
          }
          return h;
        });
      };

      const checkDateHasSubmitted = (date: Dayjs) => {
        const inputKey = date.format(CALENDAR_DATE);
        for (const claim of claims as Claim[]) {
          if (rateType === "M" || rateType === "L") {
            const start_date = dayjs(claim.START_DATE);
            const end_date = dayjs(claim.END_DATE);

            if (
              (date.isBefore(end_date, "date") &&
                date.isAfter(start_date, "date")) ||
              date.isSame(end_date, "date") ||
              date.isSame(start_date, "date")
            ) {
              return RenderOtherBadge(claim);
            }
          } else if (rateType === "H" && claim.CLAIMS_DETAILS) {
            const claimDetails = combineClaimDtlsByDate();
            for (const claimDtl of claimDetails) {
              //Case if calendar date have CLAIMS
              if (dayjs(claimDtl.CLAIM_DATE).isSame(date, "day")) {
                if (
                  !rejectedBatchNo &&
                  ((claimDtl.STATUS !== CLAIM_STATUS.DRAFT &&
                    claimDtl.STATUS !== CLAIM_STATUS.REJECTED) ||
                    !hasInput)
                ) {
                  return RenderHourlyBadge(claim, claimDtl);
                } else if (
                  rejectedBatchNo &&
                  claimDtl.BATCH_NO !== rejectedBatchNo
                ) {
                  return RenderHourlyBadge(claim, claimDtl);
                }
              }
            }
          }
        }
        //Case if calendar date does not have CLAIMS
        if (!hasInput || date.isBefore(disableFieldBefore)) {
          return <></>;
        }
        //Loop changedHr and return numbers accordingly
        if (changedHr && changedHr[inputKey] !== undefined) {
          for (const dateKey in changedHr) {
            const inputValue = changedHr[dateKey];
            if (
              date.isSame(inputValue.date, "day") &&
              inputValue.prevState !== ""
            ) {
              if (!checkedList.includes(inputValue.prevState)) {
                return (
                  // <NumericInput
                  //   key={inputKey}
                  //   inputkey={inputKey}
                  //   onBlur={onFieldChange}
                  //   initinput={
                  //     changedHr[inputKey] ? changedHr[inputKey].hr : ""
                  //   }
                  // />
                  <></>
                );
              } else {
                return (
                  <span style={BadgeCSS}>
                    <Badge color={StatusWithEle[inputValue.prevState].color} />
                    <NumericInput
                      style={{ flex: "1 1 20px" }}
                      key={inputKey}
                      inputkey={inputKey}
                      onBlur={onFieldChange}
                      initinput={inputValue.hr.toString()}
                    />
                  </span>
                );
              }
            }
          }
        }

        return rejectedBatchNo ? (
          <></>
        ) : (
          <NumericInput
            key={inputKey}
            inputkey={inputKey}
            onBlur={onFieldChange}
            initinput={changedHr[inputKey] ? changedHr[inputKey].hr : ""}
          />
        );
      };
      const holiday_css =
        date.day() === 0 || holidays?.includes(date.format(CALENDAR_DATE))
          ? " holiday-label"
          : "";
      const calendarDateStyle = device.size === "mobile" ? { padding: 0 } : {};
      return (
        <div className="ant-picker-calendar-date" style={calendarDateStyle}>
          <div className={`ant-picker-calendar-date-value ${holiday_css}`}>
            {date.date()}
          </div>
          <div
            className="ant-picker-calendar-date-content"
            style={{ paddingTop: "10px" }}
          >
            {checkDateHasSubmitted(date)}
          </div>
        </div>
      );
    },
    [
      holidays,
      claims,
      checkedList,
      hasInput,
      changedHr,
      setChangedHr,
      disableFieldBefore,
      device.size,
      rateType,
    ]
  );

  const onChange = (list: CheckboxValueType[]) => {
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < STATUS_ARRAY.length);
    setCheckAll(list.length === STATUS_ARRAY.length);
  };

  const onCheckAllChange = (e: CheckboxChangeEvent) => {
    setCheckedList(e.target.checked ? STATUS_ARRAY : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };


  useEffect(() => {
    if (_.isEmpty(holidays)) {
      const firstDayofMonth = dayjs()
        .subtract(1, "d")
        .startOf("M")
        .format(CALENDAR_DATE);
      fetchPublicHoliday(firstDayofMonth);
    }
  }, [fetchPublicHoliday, holidays]);

  const alignCSS: React.CSSProperties = {
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
    alignItems: "flex-start",
  };
  const alignCSSMobile: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    alignItems: "stretch",
  };
  const alignStyle = device.size === "mobile" ? alignCSSMobile : alignCSS;

  const statusListRender = () => {
    let statusArr = STATUS_ARRAY;
    if (isApprover) {
      statusArr = APPROVER_STATUS_ARRAY;
    } else if (isEndorser) {
      statusArr = ENDORSER_STATUS_ARRAY;
    }

    return statusArr.map((status) => (
      <Col span={24} key={status}>
        <Checkbox value={status}>
          <Badge {...StatusWithEle[status]} />
        </Checkbox>
      </Col>
    ));
  };

  return (
    <div style={alignStyle}>
      <Calendar
        dateFullCellRender={dateFullCellRender}
        validRange={validRange}
        value={defaultMonth}
        onSelect={onDateSelect}
      />
      {displayCheckBox && (
        <Card
          className="polyu-color-card"
          title={
            <>
              <div>Submission Status</div>
            </>
          }
        >
          <Checkbox
            indeterminate={indeterminate}
            onChange={onCheckAllChange}
            checked={checkAll}
          >
            Check All
          </Checkbox>
          <Divider />
          <Checkbox.Group onChange={onChange} value={checkedList}>
            <Row gutter={[0, 12]}>{statusListRender()}</Row>
          </Checkbox.Group>
        </Card>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    device: state.session.device,
    holidays: state.data.holidays,
  };
};

const mapDispatchToProps = (dispatch) => ({
  reset: () => {
    dispatch({ type: "RESET-RESULT" });
  },
  fetchPublicHoliday: (firstDayofMonth) => {
    dispatch(getPublicHoliday(firstDayofMonth));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarWithLabels);
